import { Component } from '@angular/core';
import { MessagingService } from './shared/messaging.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {

    constructor(private messagingService: MessagingService) {}

    ngOnInit() {
    // this.messagingService.requestPermissionAndGetToken();
    this.messagingService.listen();
    // alert("worked")
  }
}
